import { useDomainPath } from '../auth/auth.context';
import { get } from '../fetch';
import { useEffect, useState } from 'react';

/**
 * Hook personnalisé pour récupérer la liste des bus par direction
 *
 * Ce hook :
 * - Récupère la liste des bus disponibles pour une direction donnée
 * - Met à jour automatiquement l'état local
 * - Retourne la liste des entités bus avec nom et ID
 *
 * Logique métier :
 * - Appel API avec direction (aller/retour)
 * - Gestion automatique de l'état de chargement
 * - Retour des entités avec nom et ID pour les sélecteurs
 *
 * @param direction Direction du trajet de bus (aller ou retour)
 * @returns Liste des bus disponibles pour la direction
 */
export function useBuses(direction: CRM.BusTravelDirection) {
  const [buses, setBuses] = useState<CRM.EntityName[]>([]);
  const busTravelPath = useDomainPath('/busTravel');

  useEffect(() => {
    get<CRM.EntityName[]>(busTravelPath+'/entitynamesbusdriver/'+direction).then(setBuses);
  }, [busTravelPath, direction]);

  return buses;
}
